import { ReactComponent as HeroCourses } from 'images/icons/home-hero-courses.svg';
import { ReactComponent as HeroTraining } from 'images/icons/home-hero-training.svg';
import { ReactComponent as HeroExp } from 'images/icons/home-hero-exp.svg';
import { ReactComponent as HeroCertificate } from 'images/icons/home-hero-certificate.svg';
import { ReactComponent as HeroRally } from 'images/icons/home-hero-rally.svg';

type IconComponent = React.FC<React.SVGAttributes<SVGElement>>;

export type IconsMap = {
  HeroCourses: IconComponent;
  HeroTraining: IconComponent;
  HeroExp: IconComponent;
  HeroCertificate: IconComponent;
  HeroRally: IconComponent;
};

const heroIcons: IconsMap = {
  HeroCourses,
  HeroTraining,
  HeroExp,
  HeroCertificate,
  HeroRally
};

export default heroIcons;
